import script from "./CreatePropertyButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatePropertyButton.vue?vue&type=script&setup=true&lang=ts"

import "./CreatePropertyButton.vue?vue&type=style&index=0&id=08a176c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a176c6"]])

export default __exports__